import type Feriado from "@/Models/geral/data/Feriado";
import { Col, Form, FormInstance, FormProps, Input, InputNumber, Row } from "antd";
import { forwardRef } from "react";
import MesSelect from "../mes/MesSelect";
import EstadoSelect from "@/Components/Populados/Pessoa/Endereco/Estado/EstadoSelect";
import MunicipioSelect from "@/Components/Populados/Pessoa/Endereco/Municipio/MunicipioSelect";

export interface IFeriadoFormType {
    feriado:Feriado;
}

export interface IFeriadoFormBasicRef extends FormInstance<IFeriadoFormType> {

}

export interface IFeriadoFormBasicProps extends Omit<FormProps<IFeriadoFormType>, "children"> {
    codigo?: number;
}

const FeriadoFormBasic = forwardRef<IFeriadoFormBasicRef, IFeriadoFormBasicProps>(function FeriadoFormBasic(
    {
        form: formParam,
        initialValues,
        layout,
        disabled,
        ...rest
    },
    ref
) {
    const [newForm] = Form.useForm<IFeriadoFormType>();
    const form = formParam ?? newForm;

    const codEstadoFormValue = Form.useWatch(["feriado", "codEstado"], form);

    const initValues = { 
        ...(initialValues ?? {}),
        feriado : {
            ...(initialValues?.feriado ?? {}),
            ano : new Date().getFullYear()
        }
    };

    return <Form
        {...rest}
        ref={ref}
        form={form}
        disabled={disabled}
        layout={layout ?? "vertical"}
        size={"small"}
        labelCol={{
            style : {
                fontWeight : "bold"
            }
        }}
        initialValues={initValues}
    >
        <Row gutter={8} wrap>
            <Form.Item<IFeriadoFormType> name={["feriado", "codigo"]} hidden>
                <Input hidden />
            </Form.Item>
            <Col xs={24} sm={12} md={6} lg={5} xl={2} xxl={2}>
                <Form.Item<IFeriadoFormType> label="Ano" rules={[ { required: false } ]} name={["feriado", "ano"]}>
                    <InputNumber placeholder="Todos" />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={5} xl={3} xxl={3}>
                <Form.Item<IFeriadoFormType> label="Mês" rules={[ { required: true }]} name={["feriado", "mes"]}>
                    <MesSelect />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={5} xl={3} xxl={2}>
                <Form.Item<IFeriadoFormType> label="Dia" name={["feriado", "dia"]} rules={[ 
                    { required: true }, 
                    { 
                        async validator(rule, value, callback) {
                            if (value == undefined) return Promise.resolve();
                            value = Number.parseInt(value);

                            if (!isNaN(value) && isFinite(value) && value >= 1 && value <= 31) {
                                return Promise.resolve();
                            }
                            
                            return Promise.reject(new Error('O dia deve ser um número entre 1 e 31!'));
                        }
                    } 
                ]}>
                    <InputNumber />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={8} xl={5} xxl={4}>
                <Form.Item<IFeriadoFormType> label="Nome" rules={[ { required: true }, { min: 3 }, { max: 150 }]} name={["feriado", "nome"]}>
                    <Input maxLength={150} />
                </Form.Item>
            </Col>
            {/* <Col xs={24} sm={12} md={6} lg={5} xl={4} xxl={3}>
                <Form.Item<IFeriadoFormType> label="Estado" rules={[ { required: false }]} name={["feriado", "codEstado"]}>
                    <EstadoSelect placeholder="Todos" allowClear />
                </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} lg={5} xl={4} xxl={3}>
                <Form.Item<IFeriadoFormType> label="Município" rules={[ { required: false }]} name={["feriado", "codMunicipio"]}>
                    <MunicipioSelect codEstado={codEstadoFormValue} disabled={!!!codEstadoFormValue} allowClear placeholder="Todos" />
                </Form.Item>
            </Col> */}
        </Row>
    </Form>
});

export default FeriadoFormBasic;